import React, { useState } from 'react';
import { Box } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { insertStation } from '../../actions/supervisorActions';
import { useAppDispatch } from '../hooks';
import { ParentSelect } from '../interface/ParentSelect';
import { StationInsertionDialogProps } from './dialogs';

export function StationInsertionDialog(props: StationInsertionDialogProps) {
  const dispatch = useAppDispatch();

  const [chosenLineGuid, setChosenLineGuid] = useState<string>();
  const lineGuid = chosenLineGuid ?? props.defaultLineGuid;

  function onSubmit() {
    dispatch(closeCurrentPopup());
    dispatch(insertStation(props.stationGuid, lineGuid!));
  }

  return (
    <Dialog
      title="Add station to line"
      submitText="Add"
      onSubmit={onSubmit}
      submitDisabled={!lineGuid}
      onCancel="close"
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <Box sx={{ marginTop: 1 }}>
          <ParentSelect
            includeLines
            label="Line"
            parentGuid={lineGuid}
            onChange={(guid) => setChosenLineGuid(guid ?? undefined)}
          />
        </Box>

        <input type="submit" style={{ display: 'none' }} />
      </form>
    </Dialog>
  );
}
